"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gitalkComponent = _interopRequireDefault(require("@suziwen/gitalk/dist/gitalk-component"));

var _jsxFileName = "/home/suziwen/jobdisk/git/gatsby-plugin-gitalk/src/components/Gitalk.jsx";

var GGitalk = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(GGitalk, _React$Component);

  function GGitalk(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.pluginConfig = typeof GATSBY_GITALK_CONFIG !== "undefined" && GATSBY_GITALK_CONFIG !== '' ? GATSBY_GITALK_CONFIG : '';
    return _this;
  }

  var _proto = GGitalk.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        options = _this$props.options,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["options"]);
    var gitalkConfig = (0, _extends2.default)({}, this.pluginConfig, options);

    if (typeof window !== 'undefined') {
      return /*#__PURE__*/_react.default.createElement(_gitalkComponent.default, (0, _extends2.default)({}, props, {
        options: gitalkConfig,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 16,
          columnNumber: 9
        }
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
  };

  return GGitalk;
}(_react.default.Component);

exports.default = GGitalk;